// @ts-nocheck

export type AdminTemplatesListOrdering =
  typeof AdminTemplatesListOrdering[keyof typeof AdminTemplatesListOrdering];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTemplatesListOrdering = {
  "-created_at": "-created_at",
  "-display_name": "-display_name",
  "-display_order": "-display_order",
  created_at: "created_at",
  display_name: "display_name",
  display_order: "display_order",
} as const;
